/**
 * AppLauncher — apps-head + 4-up grid per tmp/platform-mockups/launcher.html.
 */
import type { App } from '@/services/apps';
import AppTile from './AppTile';

interface AppLauncherProps {
  apps: App[];
  loading?: boolean;
  onAppClick?: (app: App) => void;
  className?: string;
}

export default function AppLauncher({
  apps,
  loading = false,
  onAppClick,
}: AppLauncherProps) {
  if (loading) {
    return (
      <section>
        <header className="apps-head">
          <h2 className="apps-head__title">
            Your <em>apps</em>
          </h2>
          <span className="apps-head__count">loading</span>
        </header>
        <div
          className="apps-grid"
          role="list"
          aria-busy="true"
          aria-label="Loading apps"
        >
          {Array.from({ length: 4 }, (_, i) => (
            <div
              key={i}
              role="listitem"
              className="app-tile"
              style={{ opacity: 0.4 }}
              aria-hidden="true"
            >
              <div className="app-tile__head">
                <span className="app-tile__mark" />
                <span className="app-tile__live-dot" data-status="coming-soon">
                  loading
                </span>
              </div>
              <div className="app-tile__body">
                <h3 className="app-tile__name">—</h3>
              </div>
            </div>
          ))}
        </div>
      </section>
    );
  }

  const activeCount = apps.filter((a) => a.status === 'active').length;

  return (
    <section>
      <header className="apps-head">
        <h2 className="apps-head__title">
          Your <em>apps</em>
        </h2>
        <span className="apps-head__count">
          {activeCount} {activeCount === 1 ? 'app' : 'apps'} · all signed in
        </span>
      </header>
      <div className="apps-grid" role="list" aria-label="App launcher">
        {apps.map((app) => (
          <div key={app.id} role="listitem">
            <AppTile app={app} onClick={onAppClick} />
          </div>
        ))}
      </div>
    </section>
  );
}
